import React, {useRef} from "react";
import { connect } from "react-redux";
import {injectIntl} from "react-intl";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import SaveIcon from "@mui/icons-material/Save";

import {setLookIntroStep, setLookOverlayOpened} from "../../../../actions/lookFunctions";
import {ROUTES} from "../../../../routes";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../core/constants";
import LookIntroPopper from "../lookIntro/lookIntroPopper";
import WithSavePostMessage from "../../hocs/withSavePostMessage";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../analytics";
import {isIframe} from "../../../../misc/helpers";

const LookSideBarSaveButton = (props) => {

  const {intl, lookPageOpened, setLookOverlayOpened, disabled, introStep, setLookIntroStep, sidebarButtonClicked,
    userIsLoggedIn, fabricatorData} = props;
  const anchorRef = useRef(null);

  const isLixil = isIframe() && fabricatorData.isLixil;

  if (fabricatorData.isGrohe) {
    return null
  }

  const loginOpened = lookPageOpened === ROUTES.login;

  const wishlistButtonClick = (savePostMessage) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarSave);
    if (introStep === LOOK_INTRO_STEPS.saveAndMore) {
      setLookIntroStep(introStep + 1);
      return false;
    }
    if (userIsLoggedIn) {
      savePostMessage();
    } else {
      setLookOverlayOpened(isLixil ? LOOK_OVERLAYS.questionLogin : LOOK_OVERLAYS.leadCapture);
    }
    sidebarButtonClicked();
    console.log("localStorage", window.localStorage);
  }

  const realDisabled = disabled || !!(introStep && (introStep !== LOOK_INTRO_STEPS.saveAndMore));
  const buttonTextId = isLixil ? "tooltip.wishlist" : "tooltip.save";

  return (
    <li className="look-sidebar__list-item">
      <Tooltip title={intl.formatMessage({id: buttonTextId})} placement="right">
        <div className="look-sidebar__list-item-content">
          <WithSavePostMessage>
            {(savePostMessage) => (
              <IconButton aria-label={intl.formatMessage({id: buttonTextId})}
                          ref={anchorRef}
                          disabled={realDisabled}
                          data-id="save-button"
                          className={"look-icon look-sidebar__button" + (loginOpened ? " look-icon--active" : "")
                            + (introStep === LOOK_INTRO_STEPS.saveAndMore ? " look-sidebar__button--intro" : "")}
                          onClick={() => wishlistButtonClick(savePostMessage)}>
                <SaveIcon />
              </IconButton>
            )}
          </WithSavePostMessage>
        </div>
      </Tooltip>
      <LookIntroPopper anchorRef={anchorRef} currentStep={LOOK_INTRO_STEPS.saveAndMore}/>
    </li>
  )
};

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {lookLayoutOpened, introStep} = store.lookState;
  const {userIsLoggedIn} = store.userState;
  const fabricatorData = store.fabricatorState;

  return {
    activeTheme,
    lookLayoutOpened,
    introStep,
    userIsLoggedIn,
    fabricatorData,
  };
};

const mapDispatchToProps = {
  setLookOverlayOpened,
  setLookIntroStep,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(LookSideBarSaveButton)
)
